import { showToast } from 'shared/toast/showToast'
import ItemDeletedToast from 'src/routes/(registry)/list/[slug]/components/ConfirmRegItemDeleteModal/components/ItemDeletedToast/ItemDeletedToast'

export const showItemDeletedToast = () =>
  showToast({
    render: (isOpen) => <ItemDeletedToast isOpen={isOpen} />,
    timeout: 5000,
  })
